import {
  index as baseIndex
 } from './Base';


/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all phone packages to serve in a dropdown form choice
 */
export function fetchPhonePackageProducts() {
  return baseIndex('phone_package_products', 1, 0);
}
